import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall24 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import useSidebar from '../../hooks/use-sidebar';
type AddButtonProps = {
  selected?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
const AddButton = t0 => {
  const $ = _c(15);
  let className;
  let props;
  let selected;
  if ($[0] !== t0) {
    ({
      selected,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = selected;
  } else {
    className = $[1];
    props = $[2];
    selected = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "addNode"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    isAnyOpen
  } = useSidebar();
  let t2;
  if ($[5] !== t) {
    t2 = t(_temp);
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = selected || isAnyOpen;
  let t4;
  if ($[7] !== className || $[8] !== t3) {
    t4 = cx("cursor-pointer", "w-6 h-6 rounded-full flex items-center justify-center", "bg-accent hover:bg-accent-hover focus:bg-accent-hover transition-colors duration-200", {
      "bg-accent-hover": t3
    }, className);
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoPlusSmall24 color="quinary" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props || $[12] !== t2 || $[13] !== t4) {
    t6 = <button aria-label={t2} type="button" className={t4} {...props}>{t5}</button>;
    $[11] = props;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default AddButton;
function _temp($) {
  return $.addButton;
}